import images from "./images";

const About = {
  sub: "About Us",
  heading: "Your Trusted Locksmith Partner",
  description: [
    "At LockWise, we've been safeguarding homes, businesses, and vehicles for over two decades. Our commitment to security, reliability, and fast response has made us a trusted name in the locksmith industry. Whether it's a routine lock installation or an emergency lockout, we deliver professional solutions you can count on."
  ],
  experience: {
    year: "20",
    text: "years of experience",
  },
  points: [
    {
      id: 1,
      title: 'Reliable Service',
      progress: 95,
    },
    {
      id: 2,
      title: 'Quick Response',
      progress: 90,
    },
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    src3: images.about3,
    src4: images.about4,
    alt1: "About-Image1",
    alt2: "About-Image2",
    alt3: "About-Image3",
    alt4: "About-Image4",
  },
  button: {
    text: "Learn More",
    link: "Services",
  },
};

export default About;